import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { DocumentType } from "domain/entities/document-type";

interface DocumentTypeState {
  documentType: DocumentType[];
  setDocumentType: (newDocumentType: DocumentType[] | undefined) => void;
}

export const useDocumentTypeStore = create<DocumentTypeState>()(
  devtools(
    (set) => ({
      documentType: [],
      setDocumentType: (newDocumentType) =>
        set(() => ({
          documentType: newDocumentType ? [...newDocumentType] : [],
        })),
    }),
    { name: "DocumentTypeStore" }
  )
);
